<template>
  <div class="d-flex align-center">
    <v-textarea
      hide-details
      outlined
      auto-grow
      clearable
      dense
      @keydown.enter.prevent="submit"
      :label="$t('journal.search.filters.keywords.input')"
      rows="1"
      v-model="text"
      :rules="rules"
    />
    <v-switch
      v-model="include"
      class="ml-2"
      style="width: 150px; max-width: 150px;"
      :label="include
        ? $t('journal.search.filters.included')
        : $t('journal.search.filters.excluded')"
    />
  </div>
</template>
<script>
import { nanoid } from 'nanoid';
import { criterias } from '../SearchCriteria';

export default {
  name: 'KeywordFilter',
  props: {
    params: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    text: '',
    include: true,
    id: `${criterias.KEYWORD_FILTER}/${nanoid(10)}`,
    rules: [
      v => !!v || 'Ce champs ne peut être vide',
    ],
  }),
  created() {
    if (this.params !== undefined) {
      const data = this.params.filters[0].Keywords;
      this.include = data.kind === 'Include';
      this.text = data.param;
    }
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
    getCriteria() {
      return {
        filters: [
          {
            Keywords: {
              kind: this.include ? 'Include' : 'Exclude',
              param: this.text,
              id: this.id,
            },
          },
        ],
      };
    },
  },
};
</script>
